import React from 'react';
import styled from 'styled-components';
import { Body5, Body7, Container } from '@ui';
import { FormStateContext } from '@/contexts/FormStateContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const Row = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`;
const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  cursor: pointer;
  margin: 0;
`;

export const NoRetrievalToggle = () => {
  const { state, setFormStateValue } = React.useContext(FormStateContext);
  const checked = !!state.noRetrieval;
  const handleChange = (e) => setFormStateValue('noRetrieval', e.target.checked);

  return (
    <Wrapper>
      <Row>
        <Checkbox checked={checked} onChange={handleChange} />
        <Body5>Analyze attached CSVs only (skip external data sources)</Body5>
      </Row>
      {checked && (!state.selectedCsvDocs || !state.selectedCsvDocs.length) ? (
        <Container left={24}>
          <Body7 isLowContrast>Attach at least one CSV to submit while retrieval is disabled.</Body7>
        </Container>
      ) : null}
    </Wrapper>
  );
};
